import Overlay from "../../Componentes/Overlay";
import SideMenu from "../../Componentes/SideMenu";
import SideMenuBtn from "../../Componentes/SideMenuBtn";

export default function SidebarInventarioTI({
  onClose,
  onNovoEquipamento,
  onNovoTipoAtivo,
}) {
  return (
    <Overlay state={true} changeContent={onClose}>
      <SideMenu>
        <SideMenuBtn button="NOVO EQUIPAMENTO" clickFunc={onNovoEquipamento} />
        <SideMenuBtn button="NOVO TIPO DE ATIVO" clickFunc={onNovoTipoAtivo} />
      </SideMenu>
    </Overlay>
  );
}